<template>
  <svg
    v-if="data.length > 1"
    class="wg-spark"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    aria-hidden="true"
  >
    <path :d="`${linePath} L${x(data.length - 1)} ${height} L${x(0)} ${height} Z`" :fill="color" opacity="0.10" />
    <path :d="linePath" fill="none" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    <circle :cx="x(data.length - 1)" :cy="y(data[data.length - 1])" r="2.2" :fill="color" />
  </svg>
</template>

<script>
/** Inline SVG sparkline, ported 1:1 from the design mock's Spark component.
 * Wins-only surface: green or neutral, never red. */
const COLORS = {
  up: '#25A97A',
  neutral: '#9AA6A8',
}

export default {
  name: 'WinsSparkline',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    dir: {
      type: String,
      default: 'up',
    },
    width: {
      type: Number,
      default: 64,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
  computed: {
    color () {
      return COLORS[this.dir] || COLORS.up
    },
    min () {
      return Math.min(...this.data)
    },
    span () {
      return (Math.max(...this.data) - this.min) || 1
    },
    linePath () {
      return this.data
        .map((v, i) => (i ? 'L' : 'M') + this.x(i).toFixed(1) + ' ' + this.y(v).toFixed(1))
        .join(' ')
    },
  },
  methods: {
    x (i) {
      return (i / (this.data.length - 1)) * (this.width - 2) + 1
    },
    y (v) {
      return this.height - 3 - ((v - this.min) / this.span) * (this.height - 6)
    },
  },
}
</script>

<style lang="scss" scoped>
.wg-spark {
  display: block;
  flex: none;
  overflow: visible;
}
</style>
